import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/order-form/remove_button.svg'
import _imports_1 from '@/assets/images/order-form/add_button.svg'


const _withScopeId = n => (_pushScopeId("data-v-42f4b9e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "ご利用国", -1))
const _hoisted_2 = { class: "area-select" }
const _hoisted_3 = { class: "select-panel" }
const _hoisted_4 = { class: "select-boxes" }
const _hoisted_5 = { class: "select-box-body" }
const _hoisted_6 = { class: "select-box-inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "search-button" }, "ご利用プランを検索", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pull_down_select = _resolveComponent("pull-down-select")!
  const _component_input_field = _resolveComponent("input-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrySelectForms, (form, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "select-box-group",
              key: form.key
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_input_field, {
                    label: '渡航先エリア' + (index !== 0 ? index + 1 : ''),
                    "input-name": form.areaInputName,
                    class: "area"
                  }, {
                    default: _withCtx(({ inputName }) => [
                      _createVNode(_component_pull_down_select, {
                        options: _ctx.areaSelectOptions,
                        modelValue: _ctx.formData[index].area,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].area) = $event),
                        name: inputName,
                        rules: _ctx.validRules.area,
                        onChange: 
                    () => {
                      _ctx.formData[index].country = '';
                    }
                  
                      }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "name", "rules", "onChange"])
                    ]),
                    _: 2
                  }, 1032, ["label", "input-name"]),
                  _createVNode(_component_input_field, {
                    label: '国と地域' + (index !== 0 ? index + 1 : ''),
                    "input-name": form.countryInputName,
                    class: "country"
                  }, {
                    default: _withCtx(({ inputName }) => [
                      _createVNode(_component_pull_down_select, {
                        options: form.countryOptions,
                        modelValue: _ctx.formData[index].country,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].country) = $event),
                        name: inputName,
                        rules: _ctx.validRules.country,
                        disabled: !form.isAreaSelected
                      }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "name", "rules", "disabled"])
                    ]),
                    _: 2
                  }, 1032, ["label", "input-name"])
                ]),
                _withDirectives(_createElementVNode("img", {
                  class: "removeSelect",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeAreaSelectForm())),
                  src: _imports_0
                }, null, 512), [
                  [_vShow, _ctx.countrySelectForms.length === index + 1 && index !== 0]
                ])
              ]),
              (
              index + 1 === _ctx.formStatus.formIndexNum &&
              index + 1 < _ctx.constants.maxAreaForms
            )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "addSelect",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addAreaSelectForm()))
                  }, [
                    _hoisted_7,
                    _createTextVNode(" 渡航先を追加する ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _hoisted_8
      ])
    ])
  ], 64))
}